export const tokenPerBox = [1600, 2400, 2400, 2400, 2000, 10000, 15000];
export const ratioHonorToToken = 6000 / 100000000;
export const mobInfo = {
  Ex: {
    hostToken: 22,
    victoryToken: 20,
    mvpToken: 14,
    soloHonor: 51000,
    AP: 30,
    BP: 1,
    meat: 0,
    meatGain: 3
  },
  ExPlus: {
    hostToken: 26,
    victoryToken: 20,
    mvpToken: 20,
    soloHonor: 88000,
    AP: 30,
    BP: 1,
    meat: 0,
    meatGain: 10.9
  },
  Hell90: {
    hostToken: 45,
    victoryToken: 20,
    mvpToken: 18,
    soloHonor: 260000,
    AP: 30,
    BP: 2,
    meat: 5
  },
  Hell95: {
    hostToken: 55,
    victoryToken: 30,
    mvpToken: 26,
    soloHonor: 910000,
    AP: 40,
    BP: 3,
    meat: 10
  },
  Hell100: {
    hostToken: 80,
    victoryToken: 48,
    mvpToken: 40,
    soloHonor: 2650000,
    AP: 50,
    BP: 3,
    meat: 20
  },
  Hell150: {
    hostToken: 120,
    victoryToken: 85,
    mvpToken: 52,
    soloHonor: 4100000,
    AP: 50,
    BP: 3,
    meat: 20
  },
  Hell200: {
    hostToken: 160,
    victoryToken: 110,
    mvpToken: 68,
    soloHonor: 13300000,
    AP: 50,
    BP: 3,
    meat: 20
  }
};
